import { render } from "./ProductCertificateLink.vue?vue&type=template&id=ea0bb210&scoped=true"
import script from "./ProductCertificateLink.vue?vue&type=script&lang=js"
export * from "./ProductCertificateLink.vue?vue&type=script&lang=js"

import "./ProductCertificateLink.vue?vue&type=style&index=0&id=ea0bb210&lang=scss&scoped=true"
import "./ProductCertificateLink.vue?vue&type=style&index=1&id=ea0bb210&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea0bb210"]])

export default __exports__